import { CommunicationsSettingBase } from './notifications-settings-base.model';

export class EmailCommunicationSetting extends CommunicationsSettingBase {
  id: number;
  templateReferenceId: number;
  senderName: string;
  senderEmail: string;
  emailJson: string;
  emailHtml: string;
  emailSubjectLine: string;
  createdFromEmailTemplateId: number;
}
